import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2, Pencil } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";

interface Factory {
  city: string;
}

const Index = () => {
  const [data, setData] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setReload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  const [provinceID, setProvinceID] = useState<any>("");
  // Get Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // پارامترهای پایه
        const params: any = {
          sort_by: "updated_at",
          sort_order: "desc",
        };
        // فقط اگر مقدار معتبر داشت city_id اضافه کن
        if (provinceID && provinceID !== "null") {
          params.province_id = provinceID;
          const res = await axios.get("https://api.havirkesht.ir/city/", {
            params,
          });
          const items = res?.data?.items || [];
          setData(items);
          setload(items.length <= 0);
        }
      } catch (error: any) {
        console.error("Error fetching data:", error);
        setErrorMessage(
          error?.message ? "" : "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
        );
        setload(true);
      }
    };
    fetchData();
  }, [reload, provinceID]);

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataList, setDataList] = useState<any>([]);
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/province/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDataList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  // Delete Data
  // باز کردن مدال و ذخیره آیتم انتخاب شده
  const onClickDelete = (cell: any) => {
    setDeleteModal(true); // باز کردن مدال
    if (cell.city) {
      setEventData(cell.city); // ذخیره داده انتخاب شده
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      const response = await axios.delete(
        `https://api.havirkesht.ir/city/${eventData}`
      );
      if (response.status === 200) {
        toast.success("عملیات حذف با موفقیت انجام شد");
      } else {
        toast.success("حذف با خطا مواجه شد");
      }
      setReload(!reload);
      setDeleteModal(false); // بستن مدال
      setEventData(null); // پاک کردن داده انتخاب شده
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // prevent default form submission
    e.preventDefault();
    validation.handleSubmit(); // manually trigger form validation and submission
  };
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      city: "",
    },
    validationSchema: Yup.object({
      city: Yup.string().required("لطفاً شهرستان را انتخاب کنید"),
    }),

    onSubmit: async (values: any) => {
      try {
        const newData = {
          city: values.city,
          province_id: Number(provinceID),
        };

        const response = await axios.post(
          "https://api.havirkesht.ir/city/",
          newData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 201) {
          toast.success(` شهرستان جدید ثبت شد`);
          setReload(!reload);
        } else {
          toast.success(` خطا در ثبت شهرستان `);
        }
      } catch (error) {
        console.log(error);
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm(); // Reset form when closing the modal
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm(); // Reset form when opening the modal for a new record
    }
  }, [show, validation]);

  const columns = useMemo(
    () => [
      {
        header: "نام شهرستان",
        accessorKey: "city",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#!"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#!"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            {/* <Link to="#!" onClick={() => handleUpdateDataClick(cell.row.original)}>
            <Pencil className="size-4" />
          </Link> */}
            <Link to="#!" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت شهرستان" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center" // موقعیت وسط
        closeButton={false} // حذف دکمه بستن
        limit={1} // محدود کردن تعداد پیام‌ها
        rtl={true} // فعال کردن راست‌چین
        className="font-Bold text-lg"
      />

      {errorMessage && <div>{errorMessage}</div>}
      <div className="flex w-80 mb-3  items-center gap-4">
        <label
          htmlFor="province"
          className="text-base font-medium  flex-shrink-0"
        >
          استان:
        </label>
        <select
          id="province"
          className="flex-1 p-2 border border-gray-200  rounded bg-white text-gray-900 dark:border-gray-200"
          onChange={(e) => setProvinceID(e.target.value)}
        >
          <option value="null">انتخاب استان</option>
          {dataList?.map((data: any) => (
            <option key={data.id} value={data.id}>
              {data?.province}
            </option>
          ))}
        </select>
      </div>
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع شهرستان ها (<b className="total-Employs">{data?.length}</b>)
            </h6>
            <div className="shrink-0">
              <Link
                to="#!"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ثبت شهرستان جدید</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              data={data}
              customPageSize={10}
              isGlobalFilter={true}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      {/* Employee Modal */}
      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">اضافه کردن شهرستان </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                {/* ردیف اول - استان */}
                <div className="flex items-center gap-4">
                  <label
                    htmlFor="province"
                    className="text-base font-medium w-24 flex-shrink-0"
                  >
                    استان:
                  </label>
                  <select
                    id="province"
                    className="flex-1 p-2 border rounded bg-white text-gray-900 dark:border-gray-600"
                    onChange={(e) => setProvinceID(e.target.value)}
                  >
                    <option value="null">انتخاب استان</option>
                    {dataList?.map((data: any) => (
                      <option
                        key={`${data.id}_${Math.random()}`}
                        value={data.id}
                      >
                        {data?.province}
                      </option>
                    ))}
                  </select>
                </div>
                {validation.touched.provinceID &&
                  validation.errors.provinceID && (
                    <div className="flex justify-end">
                      <p className="text-red-400 mt-2">
                        {typeof validation.errors.provinceID === "string"
                          ? validation.errors.provinceID
                          : ""}
                      </p>
                    </div>
                  )}
                {/* ردیف دوم - شهرستان */}
                <div className="flex items-center gap-4">
                  <label
                    htmlFor="city"
                    className="text-base font-medium w-24 flex-shrink-0"
                  >
                    نام شهرستان:
                  </label>
                  <input
                    type="text"
                    id="city"
                    className="flex-1 p-2 border rounded bg-white text-gray-900 dark:border-gray-600"
                    placeholder="ثبت شهرستان"
                    name="city"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.city}
                  />
                </div>

                {/* نمایش خطا */}
                {validation.touched.city && validation.errors.city && (
                  <div className="flex justify-end">
                    <p className="text-red-400 mt-2">
                      {typeof validation.errors.city === "string"
                        ? validation.errors.city
                        : ""}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button" // keep it as type="button"
            onClick={handleClick} // use custom onClick handler
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Index;
